import { InjectionToken } from '@angular/core';

export const OCL_DECISIONS_MODAL_TOKEN = new InjectionToken<any>('OclDecisionsModalComponent');
